import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';
import { setColorByRating } from '../../../../utils/reviews';
import { defaultTheme } from 'sletat-ui-components2/dist/theme';

export interface RatingBarProps {
    rating: number;
    size?: 'S' | 'L';
}

const { theme } = defaultTheme;

interface StyledRatingBarProps extends JSSClassesProps<ComponentJSSClasses>, RatingBarProps {}

export function RatingBar(props: StyledRatingBarProps) {
    const { classes, rating, size = 'L' } = props;

    const getBarStyle = (rating: number) => {
        return {
                maxWidth: `${rating * 10}%`,
                background: rating ? setColorByRating(rating) : theme.colorVariables.bgFieldDisabled,
        };
    };

    return (
        <div
            className={
                `${classes.container}
                 ${size === 'S' ? classes.containerS : classes.containerL}`}
        >
            <div
                className={classes.rating}
                style={getBarStyle(rating)}
            />
        </div>
    );
}
